const { compileExpression, useDotAccessOperatorAndOptionalChaining } = require('filtrex');

module.exports = {
  compileExpression,
  useDotAccessOperatorAndOptionalChaining,
};
